document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-testid="standalone-add-to-cart"]');
  if (!button) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  button.dataset.added = 'true';
  const atcComponent = button.closest('add-to-cart-component');
  if (atcComponent && typeof atcComponent.animateAddToCart === 'function') {
    atcComponent.animateAddToCart();
  }

  button.disabled = true;

  (async () => {
    const scriptText = [...document.scripts]
      .map((script) => script.textContent || '')
      .find((text) => text.includes('orichiVolumeDiscounts:'));

    if (!scriptText) throw new Error('Bundle configuration not found');

    const readJson = (key, open, close) => {
      const keyIndex = scriptText.indexOf(key);
      const start = scriptText.indexOf(open, keyIndex);
      let depth = 0;
      let quoted = false;
      let escaped = false;

      for (let index = start; index < scriptText.length; index++) {
        const character = scriptText[index];

        if (quoted) {
          if (escaped) escaped = false;
          else if (character === '\\') escaped = true;
          else if (character === '"') quoted = false;
          continue;
        }

        if (character === '"') {
          quoted = true;
          continue;
        }

        if (character === open) depth++;
        else if (character === close && --depth === 0) {
          return JSON.parse(scriptText.slice(start, index + 1));
        }
      }

      throw new Error('Invalid bundle configuration');
    };

    const root = readJson('orichiVolumeDiscounts:', '[', ']')[0];
    const campaign = root.volumeDiscounts[0];
    const ruleIndex = Number(document.querySelector('input[name="rule"]:checked')?.value || 0);
    const rule = campaign.rules[ruleIndex];
    const form = button.closest('form[action*="/cart/add"]');
    let variantId = Number(form?.querySelector('[name="id"]')?.value);
    const productId = Number(String(root.products[0].productId).split('/').pop());

    if (!variantId) {
      const productResponse = await fetch(location.pathname + '.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      const productData = await productResponse.json();
      const selectedVariant = productData.variants?.find((variant) => variant.available)
        || productData.variants?.[0];
      variantId = Number(selectedVariant?.id);
    }

    if (!rule || !variantId) throw new Error('Selected bundle not found');

    const currentTime = new Date().toISOString();
    const discounts = campaign.rules.map((entry) => ({
      title: entry.title,
      quantity: entry.quantity,
      discountType: entry.discountType,
      amount: entry.amount
    }));

    const items = [{
      id: variantId,
      quantity: Number(rule.quantity) || 1,
      properties: {
        _orichiVolume: JSON.stringify({
          type: 'volume',
          differentVariants: Boolean(campaign.differentVariants),
          title: campaign.campaign,
          id: campaign.id,
          addFromProduct: productId,
          discounts,
          randomizedVariantIds: []
        }),
        _current_time: currentTime
      }
    }];

    for (const gift of rule.freeGiftItems || []) {
      const giftVariantId = Number(String(gift.variantId).split('/').pop());
      const giftQuantity = Number(gift.quantity) || 1;

      items.push({
        id: giftVariantId,
        quantity: giftQuantity,
        properties: {
          _orichiVolume: JSON.stringify({
            type: 'gift',
            addFromProduct: productId,
            title: campaign.campaign,
            option: rule.title,
            id: campaign.id,
            variantId: String(giftVariantId),
            quantity: giftQuantity,
            randomizedVariantIds: []
          }),
          _current_time: currentTime
        }
      });
    }

    const cartComponents = [...document.querySelectorAll('cart-items-component')];
    const sections = cartComponents
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);

    const Events = await import('https://cdn.shopify.com/storefront/standard-events.js');
    const deferred = Events.CartLinesUpdateEvent.createPromise();
    const source = button.closest('product-form-component') || document;

    source.dispatchEvent(new Events.CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((item) => ({
        merchandiseId: String(item.id),
        quantity: item.quantity
      })),
      promise: deferred.promise
    }));

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items,
        sections: sections.join(','),
        sections_url: location.pathname
      })
    });

    const response = await addResponse.json();

    if (!addResponse.ok || response.status) {
      throw new Error(response.description || ('Bundle add failed: ' + addResponse.status));
    }

    const cart = cartComponents[0]?.fetchCartData
      ? await cartComponents[0].fetchCartData()
      : await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store'
        }).then((cartResponse) => cartResponse.json());

    deferred.resolve({
      cart: Events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'product-form-component',
        sourceId: source.id || '',
        itemCount: items.reduce((total, item) => total + item.quantity, 0),
        productId,
        sections: response.sections,
        didError: false
      }
    });
  })()
    .catch((error) => console.error('[siaasoo-cart]', error))
    .finally(() => {
      button.disabled = false;
      setTimeout(() => {
        button.removeAttribute('data-added');
      }, 1500);
    });
}, true);

;(() => {
  if (document.getElementById('siaasoo-desktop-sticky-product-gallery')) return;
  const style = document.createElement('style');
  style.id = 'siaasoo-desktop-sticky-product-gallery';
  style.textContent = '@media screen and (min-width: 990px) { #main-product-top .product.grid > .product__media-wrapper.product__column-sticky { position: sticky !important; top: calc(var(--header-height, 111px) + 44px) !important; align-self: flex-start !important; height: max-content !important; } }';
  document.head.appendChild(style);
})();


;(() => {
  if (document.getElementById('siaasoo-product-gallery-alignment')) return;
  const style = document.createElement('style');
  style.id = 'siaasoo-product-gallery-alignment';
  style.textContent = '@media screen and (min-width: 990px) { #main-product-top .product.grid > .product__media-wrapper { transform: translateY(-99px) !important; } #main-product-top [id^="GalleryViewer"] { width: 92% !important; margin-inline: auto !important; } }';
  document.head.appendChild(style);
})();

;(() => {
  if (document.getElementById('siaasoo-judgeme-review-width-fix')) return;
  const style = document.createElement('style');
  style.id = 'siaasoo-judgeme-review-width-fix';
  style.textContent = '.shopify-section:has(> .page-width > .jdgm-horizon-widget) > .page-width { width: min(980px, 100%) !important; justify-self: center !important; }';
  document.head.appendChild(style);
})();

;(() => {
  if (document.getElementById('siaasoo-judgeme-review-image-size-fix')) return;
  const style = document.createElement('style');
  style.id = 'siaasoo-judgeme-review-image-size-fix';
  style.textContent = '#judgeme_product_reviews.jdgm-widget-revamp .jm-media-thumbnail-list__thumbnail, #judgeme_product_reviews.jdgm-widget-revamp .jm-media-thumbnail-list__thumbnail > img { width: 96px !important; height: 96px !important; max-width: 96px !important; flex: 0 0 96px !important; object-fit: cover !important; } #judgeme_product_reviews.jdgm-widget-revamp .jm-media-preview, #judgeme_product_reviews.jdgm-widget-revamp .jm-media-grid, #judgeme_product_reviews.jdgm-widget-revamp .jm-media-grid__container { height: 96px !important; } #judgeme_product_reviews.jdgm-widget-revamp .jm-media-grid__item, #judgeme_product_reviews.jdgm-widget-revamp .jm-media-grid__image-container, #judgeme_product_reviews.jdgm-widget-revamp .jm-media-grid__image { width: 96px !important; height: 96px !important; max-width: 96px !important; flex: 0 0 96px !important; object-fit: cover !important; }';
  document.head.appendChild(style);
})();

;(() => {
  const styleId = 'siaasoo-home-final-cta-button-fix';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #shopify-section-template--20382904746161__rich_text_EwnNM4 .rich-text__buttons-template--20382904746161__rich_text_EwnNM4 {
        width: fit-content !important;
        height: auto !important;
        max-width: 100% !important;
        background: transparent !important;
        background-color: transparent !important;
        background-image: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  const fixButtonWrapper = () => {
    const wrapper = document.querySelector('#shopify-section-template--20382904746161__rich_text_EwnNM4 .rich-text__buttons-template--20382904746161__rich_text_EwnNM4');
    if (!wrapper) return;
    wrapper.style.setProperty('width', 'fit-content', 'important');
    wrapper.style.setProperty('height', 'auto', 'important');
    wrapper.style.setProperty('max-width', '100%', 'important');
    wrapper.style.setProperty('background', 'transparent', 'important');
    wrapper.style.setProperty('background-color', 'transparent', 'important');
    wrapper.style.setProperty('background-image', 'none', 'important');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixButtonWrapper, { once: true });
  } else {
    fixButtonWrapper();
  }
  document.addEventListener('shopify:section:load', fixButtonWrapper);
})();


;(() => {
  const styleId = 'siaasoo-review-product-mobile-gallery-fix';
  const sectionSelector = '#shopify-section-template--20382905106609__main';
  const gallerySelector = '#Slider-Gallery-template--20382905106609__main';

  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media screen and (max-width: 989px) {
        ${sectionSelector} ${gallerySelector} {
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          height: auto !important;
        }
        ${sectionSelector} ${gallerySelector} > .product__media-item {
          flex: 0 0 100% !important;
          width: 100% !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const applyMobileGalleryLayout = () => {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    const gallery = document.querySelector(`${sectionSelector} ${gallerySelector}`);
    if (!gallery) return;
    gallery.style.setProperty('flex-direction', 'row', 'important');
    gallery.style.setProperty('flex-wrap', 'nowrap', 'important');
    gallery.style.setProperty('height', 'auto', 'important');
    gallery.querySelectorAll(':scope > .product__media-item').forEach((item) => {
      item.style.setProperty('flex', '0 0 100%', 'important');
      item.style.setProperty('width', '100%', 'important');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMobileGalleryLayout, { once: true });
  } else {
    applyMobileGalleryLayout();
  }
  document.addEventListener('shopify:section:load', applyMobileGalleryLayout);
})();


;

;(() => {
  const styleId = 'siaasoo-header-layout-and-icon-fix';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    /* Desktop Header Layout */
    @media screen and (min-width: 990px) {
      .header {
        display: grid !important;
        grid-template-areas: "heading navigation icons" !important;
        grid-template-columns: auto 1fr auto !important;
        align-items: center !important;
        column-gap: 1.2rem !important;
        padding: 10px 20px !important;
        max-width: 1440px !important;
        margin: 0 auto !important;
        min-height: 76px !important;
      }

      .header__heading-link {
        grid-area: heading !important;
        display: flex !important;
        align-items: center !important;
        text-decoration: none !important;
      }

      .header__heading-logo {
        display: block !important;
        max-width: 135px !important;
        width: 135px !important;
        height: auto !important;
        object-fit: contain !important;
      }

      .header__inline-menu {
        grid-area: navigation !important;
        display: block !important;
      }

      .header__inline-menu .list-menu,
      .header__inline-menu .list-menu--inline {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 4px 10px !important;
        margin: 0 !important;
        padding: 0 !important;
        list-style: none !important;
      }

      .header__inline-menu .header__menu-item {
        display: inline-flex !important;
        align-items: center !important;
        padding: 4px 2px !important;
        font-size: 13px !important;
        font-weight: 500 !important;
        color: #111111 !important;
        text-decoration: none !important;
        white-space: nowrap !important;
        letter-spacing: -0.15px !important;
      }

      .header__inline-menu .header__menu-item:hover {
        color: #347542 !important;
      }

      header-drawer {
        display: none !important;
      }

      .header__icons {
        grid-area: icons !important;
        display: flex !important;
        align-items: center !important;
        justify-content: flex-end !important;
        gap: 12px !important;
        margin-left: auto !important;
      }
    }

    /* Mobile Header Layout (Hamburger on LEFT, Logo in CENTER, Cart on RIGHT) */
    @media screen and (max-width: 989px) {
      .header {
        display: grid !important;
        grid-template-columns: 44px 1fr 44px !important;
        align-items: center !important;
        justify-content: space-between !important;
        padding: 8px 16px !important;
        min-height: 56px !important;
        width: 100% !important;
      }

      header-drawer,
      .header__icon--menu,
      .menu-drawer-container {
        grid-column: 1 !important;
        order: 1 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        width: 44px !important;
        margin: 0 !important;
      }

      .header__heading,
      .header__heading-link {
        grid-column: 2 !important;
        order: 2 !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        text-align: center !important;
        margin: 0 auto !important;
        width: 100% !important;
      }

      .header__heading-logo {
        max-width: 110px !important;
        width: 110px !important;
        height: auto !important;
        margin: 0 auto !important;
        display: block !important;
      }

      .header__inline-menu {
        display: none !important;
      }

      .header__icons {
        grid-column: 3 !important;
        order: 3 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: flex-end !important;
        gap: 8px !important;
        width: 44px !important;
        margin-left: auto !important;
      }
    }

    /* Icons Common Sizing & Cart Badge */
    .header__icon {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 40px !important;
      height: 40px !important;
      color: #111111 !important;
      text-decoration: none !important;
      position: relative !important;
    }

    .header__icon--cart {
      position: relative !important;
    }

    .cart-count-bubble {
      position: absolute !important;
      top: 0px !important;
      right: 0px !important;
      background-color: #111111 !important;
      color: #ffffff !important;
      min-width: 18px !important;
      height: 18px !important;
      border-radius: 9px !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      line-height: 1 !important;
      padding: 0 4px !important;
    }

    .header__icon--account svg,
    .header__icon svg,
    .menu-drawer__account svg,
    svg.icon-account,
    svg.icon-cart,
    svg.icon-hamburger,
    svg.icon-close {
      width: 20px !important;
      height: 20px !important;
      max-width: 20px !important;
      max-height: 20px !important;
      display: inline-block !important;
    }

    /* Hide recommendations section on free gift products */
    body:has(.free-gift-product-wrapper) [id*="product_recommendations"],
    body:has(.free-gift-product-wrapper) .product-recommendations {
      display: none !important;
    }

    /* Compact & Proportionate Blog Post Card Headings */
    .article-card .card__heading,
    .article-card__title,
    .blog-articles h3.card__heading,
    .blog-articles .article-card h3 {
      font-size: 14.5px !important;
      line-height: 1.35 !important;
      font-weight: 600 !important;
      margin-top: 6px !important;
      margin-bottom: 6px !important;
      color: #111111 !important;
    }
    .blog-articles .article-card .card__information {
      padding: 0.8rem 0.6rem !important;
    }

    /* Single Blog Post Typography (Headings & Content) */
    .article-template {
      max-width: 860px !important;
      margin: 0 auto !important;
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
    .article-template header {
      margin-top: 2rem !important;
      margin-bottom: 1.5rem !important;
      text-align: left !important;
    }
    .article-template__title {
      font-size: clamp(22px, 3.2vw, 30px) !important;
      font-weight: 700 !important;
      line-height: 1.3 !important;
      color: #111111 !important;
      margin-bottom: 1rem !important;
    }
    .article-template__content.rte {
      font-size: 15.5px !important;
      line-height: 1.7 !important;
      color: #2b2b2b !important;
    }
    .article-template__content.rte h1 {
      font-size: clamp(19px, 2.5vw, 24px) !important;
      font-weight: 700 !important;
      line-height: 1.35 !important;
      margin-top: 2rem !important;
      margin-bottom: 0.8rem !important;
      color: #111111 !important;
    }
    .article-template__content.rte h2 {
      font-size: clamp(17px, 2.2vw, 20px) !important;
      font-weight: 600 !important;
      line-height: 1.38 !important;
      margin-top: 1.8rem !important;
      margin-bottom: 0.7rem !important;
      color: #111111 !important;
    }
    .article-template__content.rte h3 {
      font-size: clamp(15px, 1.8vw, 17.5px) !important;
      font-weight: 600 !important;
      line-height: 1.4 !important;
      margin-top: 1.4rem !important;
      margin-bottom: 0.5rem !important;
      color: #222222 !important;
    }
    .article-template__content.rte h4,
    .article-template__content.rte h5,
    .article-template__content.rte h6 {
      font-size: clamp(14px, 1.5vw, 16px) !important;
      font-weight: 600 !important;
      line-height: 1.4 !important;
      margin-top: 1.2rem !important;
      margin-bottom: 0.4rem !important;
      color: #333333 !important;
    }
    .article-template__content.rte p {
      font-size: 15.5px !important;
      line-height: 1.7 !important;
      margin-bottom: 1.2rem !important;
      color: #333333 !important;
    }
    @media screen and (max-width: 768px) {
      .article-template {
        padding-left: 16px !important;
        padding-right: 16px !important;
      }
      .article-template__title {
        font-size: 22px !important;
        line-height: 1.3 !important;
      }
      .article-template__content.rte h1 {
        font-size: 19px !important;
      }
      .article-template__content.rte h2 {
        font-size: 17px !important;
      }
      .article-template__content.rte h3 {
        font-size: 15px !important;
      }
      .article-template__content.rte p,
      .article-template__content.rte {
        font-size: 14.5px !important;
        line-height: 1.65 !important;
      }
    }

    /* 3-Link Quick Navigation / Breadcrumbs */
    .siaasoo-quick-nav {
      display: flex !important;
      align-items: center !important;
      flex-wrap: wrap !important;
      gap: 6px 8px !important;
      margin: 8px 0 16px 0 !important;
      font-size: 14.5px !important;
      font-weight: 500 !important;
      line-height: 1.4 !important;
    }
    .siaasoo-quick-nav--center {
      justify-content: center !important;
    }
    .siaasoo-quick-nav a {
      color: #347542 !important;
      text-decoration: underline !important;
      text-underline-offset: 3px !important;
      transition: color 0.2s ease, opacity 0.2s ease !important;
    }
    .siaasoo-quick-nav a:hover {
      color: #1d1a2d !important;
      opacity: 0.85 !important;
    }
    .siaasoo-quick-nav .quick-nav__sep {
      color: #888888 !important;
      font-weight: 400 !important;
      user-select: none !important;
    }

    /* Hide legacy manually pasted broken inline links inside article body */
    .article-template__content p:has(a[href*="siaasoo-massager"]),
    .article-template__content p:has(a[href*="siaasoo-blogs-official-news"]),
    .article-template__content p:has(a[href*="/blogs/news"]),
    .article-template__content p:has(a[href*="All Blogs & News"]) {
      display: none !important;
    }

    /* Homepage & Global CTA Button Polish */
    .rich-text__buttons .button,
    .image-with-text .button,
    .image-with-text__content .button {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 10px 26px !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 1.3 !important;
      border-radius: 8px !important;
      background-color: #3a6e42 !important;
      color: #ffffff !important;
      text-decoration: none !important;
      transition: opacity 0.2s ease !important;
      margin: 16px auto 0 auto !important;
      width: auto !important;
      min-width: fit-content !important;
      max-width: fit-content !important;
      box-shadow: none !important;
    }
    .rich-text__buttons .button:hover,
    .image-with-text .button:hover,
    .image-with-text__content .button:hover {
      background-color: #3a6e42 !important;
      color: #ffffff !important;
      opacity: 0.9 !important;
    }
    @media screen and (max-width: 768px) {
      .rich-text__buttons .button,
      .image-with-text .button,
      .image-with-text__content .button {
        padding: 9px 22px !important;
        font-size: 13px !important;
        width: auto !important;
        max-width: fit-content !important;
      }
    }
  `;
  document.head.appendChild(style);

  // JS cleanup for browsers/DOM
  try {
    document.querySelectorAll('.article-template__content p').forEach(p => {
      const text = p.textContent.replace(/\s+/g, ' ').trim();
      if (
        text === '/ SiaaSoo Massager /' ||
        text === '/ All Blogs & News /' ||
        text.startsWith('/ SiaaSoo Massager') ||
        text.includes('siaasoo-blogs-official-news') ||
        (p.querySelector('a[href*="siaasoo-massager"]') && p.querySelector('a[href*="blogs"]'))
      ) {
        p.style.display = 'none';
        p.remove();
      }
    });
  } catch (e) {}
})();

/* Ensure Quick Nav links exist on blog posts and about/policy pages only (NOT contact or track order) */
(function ensurePageBreadcrumbs() {
  function cleanupAndInject() {
    const path = window.location.pathname.toLowerCase();
    // Exclude Contact Us and Track Your Order pages
    if (path.includes('contact') || path.includes('track')) {
      document.querySelectorAll('.siaasoo-quick-nav').forEach(el => el.remove());
      return;
    }

    if (!/^\/(pages\/about|policies)(\/|$)/.test(window.location.pathname)) return;
    if (document.querySelector('.siaasoo-quick-nav')) return;

    const targetHeading = document.querySelector('.shopify-policy__title h1, .main-page-title, main h1');
    if (targetHeading && !targetHeading.parentElement.querySelector('.siaasoo-quick-nav')) {
      const nav = document.createElement('nav');
      nav.className = 'siaasoo-quick-nav';
      nav.setAttribute('aria-label', 'Page Navigation');
      nav.innerHTML = `
        <span class="quick-nav__item"><a href="/">Home</a></span>
        <span class="quick-nav__sep">/</span>
        <span class="quick-nav__item"><a href="/products/siaasoo-massager">SiaaSoo Massager</a></span>
        <span class="quick-nav__sep">/</span>
        <span class="quick-nav__item"><a href="/blogs/news">All Blogs &amp; News</a></span>
      `;
      targetHeading.insertAdjacentElement('afterend', nav);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupAndInject);
  } else {
    cleanupAndInject();
  }
})();


/* Restore article-card image ratios on the blog listing only. */
(function restoreBlogCardImages() {
  if (!/^\/blogs(?:\/|$)/.test(window.location.pathname)) return;
  const css = `
    #MainContent .article-card .card__inner.ratio {
      --ratio-percent: 66.6667% !important;
    }
    #MainContent .article-card .card__media,
    #MainContent .article-card .article-card__image {
      height: 100% !important;
    }
  `;
  if (!document.getElementById('siaasoo-blog-card-image-ratio')) {
    const style = document.createElement('style');
    style.id = 'siaasoo-blog-card-image-ratio';
    style.textContent = css;
    document.head.appendChild(style);
  }
})();


/* Complete the blog card media ratio repair where Atlas sets the card inner height to zero. */
(function completeBlogCardImageRepair() {
  if (!/^\/blogs(?:\/|$)/.test(window.location.pathname)) return;
  const css = `
    #MainContent .article-card .card__inner.ratio {
      height: 0 !important;
      min-height: 0 !important;
      padding-bottom: 66.6667% !important;
      position: relative !important;
    }
    #MainContent .article-card .card__inner.ratio::before {
      display: none !important;
    }
    #MainContent .article-card .card__inner.ratio > .card__media,
    #MainContent .article-card .card__inner.ratio .article-card__image {
      position: absolute !important;
      inset: 0 !important;
      width: 100% !important;
      height: 100% !important;
    }
    #MainContent .article-card .card__inner.ratio img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
    }
  `;
  const style = document.getElementById('siaasoo-blog-card-image-ratio') || document.head.appendChild(Object.assign(document.createElement('style'), { id: 'siaasoo-blog-card-image-ratio' }));
  if (!style.textContent.includes('completeBlogCardImageRepair')) style.textContent += '\n/* completeBlogCardImageRepair */\n' + css;
})();


/* Restore the desktop product grid only for the Free Gift Products collection. */
(function restoreFreeGiftDesktopGrid() {
  if (window.location.pathname !== '/collections/free-gift-products') return;
  const css = `
    @media screen and (min-width: 750px) {
      #MainContent .product-grid-container {
        display: block !important;
        width: 100% !important;
      }
      #MainContent .product-grid {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 24px !important;
        width: 100% !important;
      }
      #MainContent .product-grid > li,
      #MainContent .product-grid .grid__item {
        width: auto !important;
        max-width: none !important;
        min-width: 0 !important;
      }
    }
  `;
  if (!document.getElementById('siaasoo-free-gift-desktop-grid')) {
    const style=document.createElement('style');
    style.id='siaasoo-free-gift-desktop-grid';
    style.textContent=css;
    document.head.appendChild(style);
  }
})();

/* Guaranteed instant checkout redirect on button click */
;(() => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#checkout, .cart__checkout-button, [name="checkout"], button[form="cart-drawer-checkout-form"]');
    if (!btn || btn.disabled) return;

    // Show instant visual feedback and navigate directly to /checkout
    const form = btn.closest('form') || document.getElementById('cart-drawer-checkout-form');
    if (form) {
      // Let standard submission trigger, but ensure redirect within 200ms if stalled
      setTimeout(() => {
        if (!window.location.pathname.includes('/checkout')) {
          window.location.href = '/checkout';
        }
      }, 200);
    } else {
      window.location.href = '/checkout';
    }
  }, true);
})();
